import React, { useState, useEffect } from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card, Table } from 'react-bootstrap';
// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';
import challanListData from "./challan_data.json";

// icon
import Icon from '@mdi/react';
import { mdiFileDocumentOutline, mdiPlus } from '@mdi/js';
import CreateChallans from './CreateChallans';
import ViewInvoice from '../../../Utils/ViewInvoice';
import { showAlert } from '../../../Utils/utils';
import { toast } from 'react-toastify';

export default function Challan() {
    // Change card title
    const handleClick = event => {
        var buttonID = event.currentTarget.id;
        var button = document.getElementById(buttonID);
        var cardtitle = document.getElementById('cardTitle');
        var buttonText = button.textContent;
        cardtitle.innerHTML = buttonText;
    };

    const getStatusFromStatusID = (id) => {
        let status, color;
        switch (id) {
            case 0:
                status = "Pending";
                color = "danger";
                break;

            case 1:
                status = "";
                color = "";
                break;

            case 2:
                status = "";
                color = "";
                break;

            default:
                status = "";
                color = "";
                break;
        }

        return [status, color];
    };

    const HandlePIDelete = (POID) => {
        try {
            showAlert('Do you really want to delete this record?', 'confirm', async (result) => {
                if (result) {
                    // try {
                    //     const response = await deleteFromAPI(`FtsPurchaseOrderInvoice/${POID}/`);
                    //     if (response.status) {
                    //         toast.success('Purchase invoice deleted successfully', 'success');
                    //         FetchPIData();
                    //         UpdateDataTable();
                    //     }
                    // } catch (error) {
                    //     console.error('Error deleting purchase invoice:', error);
                    //     toast.error('purchase invoice Not Deleted', 'error');
                    // }
                }
            }, { confirmButtonText: 'Delete', cancelButtonText: 'Cancel', title: 'Are you sure?', confirmButtonColor: '#dc3545' });
        } catch (error) {
            console.error('Error deleting purchase invoice:', error);
            toast.error('Error deleting purchase invoice', 'error');
        }
    }

    // datatable
    DataTable.Buttons.jszip(JSZip);
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    useEffect(() => {
        if (!$.fn.dataTable.isDataTable('#challanListDatatable')) {
            $('#challanListDatatable').DataTable({
                dom: "flrtip",
                data: challanListData.challanListData.map(row => [
                    row.challan_number,
                    row.customer_name,
                    row.date,
                    row.total,
                    row.status,
                    row.id
                ]),
                columns: [
                    { title: "Challans#" },
                    { title: "Customer" },
                    { title: "Date" },
                    { title: "Total" },
                    {
                        title: "Status",
                        render: function (data, type, row) {
                            const [status, color] = getStatusFromStatusID(0);
                            return (`<span class="badge bg-soft-${color}" >${status}</span>`)
                        }
                    },
                    {
                        title: "Action",
                        createdCell: function (td) {
                            // Add a class to the 'Action' column cells
                            td.classList.add('py-1');
                        },
                        render: function (data, type, row) {
                            return `
                        <div class='btn-list d-flex'>
                            <button class="btn btn-light btn-sm ql-challan-viewinvoice" data-challan_id="${row[5]}">View Challan</button>
                            <button class="btn btn-light btn-sm" onClick="">Edit Challan</button>
                            <button class="btn btn-light btn-sm" onClick="">Print</button>
                            <button class="btn btn-soft-danger btn-sm px-3 ms-auto challan-delete" data-challan_id="${row[5]}">
                            <svg viewBox="0 0 24 24" role="presentation" class="icon-size-16"><path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" style="fill: currentcolor;"></path></svg>
                            </button>
                        </div>
                      `;
                        }
                    }
                ],
                autoWidth: false,
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });
            document.querySelector('#challanListDatatable tbody').addEventListener('click', function (event) {
                // Check if the click happened inside a button with class 'challan-delete'
                const deleteButton = event.target.closest('.challan-delete');
                if (deleteButton) {
                    const pi_id = deleteButton.getAttribute('data-challan_id');
                    HandlePIDelete(pi_id);
                }
                // Check if the click happened inside a button with class 'ql-challan-viewinvoice'
                const viewInvoiceButton = event.target.closest('.ql-challan-viewinvoice');
                if (viewInvoiceButton) {
                    const pi_id = viewInvoiceButton.getAttribute('data-challan_id');
                    handleShowInvoice(pi_id);
                }
            });
        }
    }, []);

    // Invoice Data
    const fromInfoData = [
        { label: 'Challan#', value: 'Oct0001' },
        { label: 'Date', value: '24-10-2024' },
        { label: 'Vendor Name', value: 'Jems Bond' },
        { label: 'Address', value: '3019 Ersel Street Venus, TX 76084' },
        { label: 'Mobile Number', value: '+91 914-366-1459' },
        { label: 'Email', value: 'JemsBond007@armyspy.com' },
        { label: 'GSTIN', value: '29ABCDE1234F1Z5' }
    ];
    const toInfoData = [
        { label: 'Name', value: 'My Business' },
        { label: 'Address', value: '417 Edgewood Road Memphis, TN 38115' },
        { label: 'Mobile Number', value: '+91 914-366-1459' },
        { label: 'GSTIN', value: '123456789000' }
    ];
    const columns = [
        { header: '#', tableText: 'srno' },
        { header: 'Item', tableText: 'item' },
        { header: 'Description', tableText: 'description' },
        { header: 'Provider', tableText: 'provider' },
        { header: 'Unit Price', tableText: 'unitPrice' },
        { header: 'Quantity', tableText: 'quantity' },
        { header: 'Discount', tableText: 'discount' },
        { header: 'Discount Amount', tableText: 'discountAmount' },
        { header: 'Tax', tableText: 'tax' },
        { header: 'Tax Amount', tableText: 'taxAmount' },
        { header: 'Total', tableText: 'total' }
    ];
    const data = [
        { srno: 1, item: 'Service', description: 'Text 001', provider: 'Provider 1', unitPrice: '5200', quantity: '1.00', discount: '', discountAmount: '', tax: '18(Inc)', taxAmount: '793.22', total: '5200' }
    ];
    const totalSummaryData = [
        { totalSummaryTitle: 'Sub Total', totalSummaryAmount: '5200' },
        { totalSummaryTitle: 'Discount', totalSummaryAmount: '0' },
        { totalSummaryTitle: 'Campaign', totalSummaryAmount: '0' },
        { totalSummaryTitle: 'Loyalty', totalSummaryAmount: '0' },
        { totalSummaryTitle: 'Taxable Amount', totalSummaryAmount: '4406.78' },
        { totalSummaryTitle: 'CGST', totalSummaryAmount: '396.61' },
        { totalSummaryTitle: 'SGST', totalSummaryAmount: '396.61' },
        { totalSummaryTitle: 'Total Tax Amount', totalSummaryAmount: '793.22' },
        { totalSummaryTitle: 'Grand Total', totalSummaryAmount: '5200' }
    ];
    const invoiceNotesData = [
        { invoiceNotesText: "Note Text" }
    ]
    // Add Invoice modal
    const [invoiceModalShow, setInvoiceModalShow] = useState(false);
    const handleShowInvoice = () => setInvoiceModalShow(true);
    const handleCloseInvoice = () => setInvoiceModalShow(false);

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col md={12}>
                                <Card>
                                    <Card.Body>
                                        <div className='d-sm-flex justify-content-between align-items-center mb-0'>
                                            <Card.Title className='mb-0' id="cardTitle">View Challans</Card.Title>
                                            <div className="custom-top-nav-tab d-flex mt-3 mt-sm-0">
                                                <ul className="nav nav-pills btn-list" id="pills-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link active" onClick={handleClick} data-text="View Challans" id="pills-view-challans-tab" data-bs-toggle="pill" data-bs-target="#pills-view-challans" type="button" role="tab" aria-controls="pills-view-challans" aria-selected="true">
                                                            <Icon path={mdiFileDocumentOutline} className="btn-icon me-1" />View Challans
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link" onClick={handleClick} data-text="Create Challan" id="pills-create-challan-tab" data-bs-toggle="pill" data-bs-target="#pills-create-challan" type="button" role="tab" aria-controls="pills-create-challan" aria-selected="false">
                                                            <Icon path={mdiPlus} className="btn-icon me-1" />Create Challan
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-view-challans" role="tabpanel" aria-labelledby="pills-view-challans-tab" tabIndex="0">
                                        <Card>
                                            <Card.Body>
                                                <Table responsive bordered className='table-nowrap' id='challanListDatatable'>
                                                    <thead className='table-light'></thead>
                                                </Table>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className="tab-pane fade" id="pills-create-challan" role="tabpanel" aria-labelledby="pills-create-challan-tab" tabIndex="0">
                                        <CreateChallans />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>

            {/* View Invoice Modal */}
            <ViewInvoice invoiceTitle="Challan Invoice" invoiceShow={invoiceModalShow} handleCloseInvoice={handleCloseInvoice} columns={columns} data={data} fromInfo={fromInfoData} toInfo={toInfoData} totalSummary={totalSummaryData} invoiceNotes={invoiceNotesData} />
        </>
    )
}
